import { NODE_ENV, WEBAPP_ROUTE_PREFIX } from '../constants';

export const getImageSrc = (imagePath: string) =>
    `${NODE_ENV === 'production' ? `${WEBAPP_ROUTE_PREFIX}/build` : `${WEBAPP_ROUTE_PREFIX}`}${imagePath}`;

export const getInfraestruturaImage = (id?: number | null) =>
    ({
        1: getImageSrc('/Common/Images/Tree/View.png'),
        2: getImageSrc('/Common/Images/Tree/Stop.png'),
        4: getImageSrc('/Common/Images/Tree/Schemas.png'),
        5: getImageSrc('/Common/Images/Tree/Schema.png'),
        6: getImageSrc('/Common/Images/Tree/Processes.png'),
        7: getImageSrc('/Common/Images/Tree/Domain.png'),
    })[id || 0] ?? getImageSrc('/Common/Images/Tree/Columns.png');

export const getSintomaImage = (id_no_tipo?: number) =>
    ({
        1: getImageSrc('/Common/Images/Tree/Cluster.png'),
        2: getImageSrc('/Common/Images/Tree/Columns.png'),
        3: getImageSrc('/Common/Images/Tree/Column.png'),
        4: getImageSrc('/Common/Images/Tree/origem.png'),
    })[id_no_tipo || 0] ?? getImageSrc('/Common/Images/Tree/Cluster.png');

export const getInfraestruturaTypeImage = (id_no_tipo?: number) =>
    ({
        2: getImageSrc('/Common/Images/Tree/layers.png'),
    })[id_no_tipo || 0] ?? getImageSrc('/Common/Images/Tree/folder.png');

export const getNavbarClientLogoImage = (instanceId: number) => {
    const paths: Record<number, string> = {
        137: '/Common/Images/Clients/logo-h2porto.png',
        143: '/Common/Images/Clients/logo-h2porto.png',
        350: '/Common/Images/Clients/logo-h2porto.png',
        // 184: '/Common/Images/Clients/logo-gere.png',
        // 232: '/Common/Images/Clients/logo-gere.png',
        184: '/Common/Images/Clients/logo-gere-bg-white.png',
        232: '/Common/Images/Clients/logo-gere-bg-white.png',
    };
    return getImageSrc(paths[instanceId] || '');
};

export const getClientLogoImageWithText = (instanceId: number) => {
    const paths: Record<number, string> = {
        137: '/Common/Images/Clients/logo-h2porto-text.png',
        143: '/Common/Images/Clients/logo-h2porto-text.png',
        350: '/Common/Images/Clients/logo-h2porto-text.png',
        184: '/Common/Images/Clients/logo-gere-bg-white.png',
        232: '/Common/Images/Clients/logo-gere-bg-white.png',
    };
    return getImageSrc(paths[instanceId] || '');
};
